<template>
  <div class="easy">
    <div class="easy__innerwrap">
      <h1 class="easy__title" v-html="benefit.title"></h1>
      <div class="easy__content">
        <ul>
          <li v-for="(item, index) in benefit.list" :key="index" v-html="item"></li>
        </ul>
      </div>
      <div class="easy__video-wrapper">
        <video class="easy__video" :src="video" controls plays-inline></video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Easy',
  props: ['benefit'],
  computed: {
    video() {
      return `static/${this.benefit.video}`;
    },
  },
};
</script>

<style lang="scss">
@import '../../styles/helpers';

.easy {
  @include section;
  padding-bottom: 200px;

  &__title {
    width: calc(9/12 * 100%);
    @include font-heading;
    position: relative;

    &::before {
      content: '';
      display: block;
      width: 301px;
      height: 156px;
      position: absolute;
      top: calc(100% - 45px);
      left: calc(100% - 200px);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url('../../assets/easy_eye.svg');
    }
  }

  &__content {
    width: calc(6/12 * 100%);
    @include font-content;
    margin-bottom: 40px;
  }

  &__video-wrapper {
    display: block;
    width: calc(11/12 * 100%);
  }

  &__video {
    display: block;
    width: 100%;
    outline: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/Easy.vue